
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/parking",
      function () {
        return require("private-next-pages/parking.js");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/parking"])
      });
    }
  